/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BuildingTypeEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export const BuildingTypeEnum = {
    NUMBER_1: 1 as BuildingTypeEnum,
    NUMBER_2: 2 as BuildingTypeEnum,
    NUMBER_3: 3 as BuildingTypeEnum,
    NUMBER_4: 4 as BuildingTypeEnum,
    NUMBER_5: 5 as BuildingTypeEnum,
    NUMBER_6: 6 as BuildingTypeEnum,
    NUMBER_7: 7 as BuildingTypeEnum,
    NUMBER_8: 8 as BuildingTypeEnum,
    NUMBER_9: 9 as BuildingTypeEnum,
    NUMBER_10: 10 as BuildingTypeEnum,
    NUMBER_11: 11 as BuildingTypeEnum
};

